import { apiClient } from './api-client';
import { ApiResponse } from '../types';

// Types for chapter notes API
export interface ChapterNotesRequest {
  chapter: string;
  subject_id: number;
  notes: Array<{
    content: string;
    questions: Array<{
      question: string;
      answer: string;
    }>;
  }>;
}

export interface ChapterNotesResponse {
  chapter_id: number;
  notes_saved: number;
  questions_saved: number;
}

export interface ChapterNotesData {
  chapter: string;
  subject_id: number;
  notes: Array<{
    id: number;
    content: string;
    questions: Array<{
      id: number;
      question: string;
      answer: string;
    }>;
  }>;
}

export const ChapterNoteService = {
  /**
   * Create a new chapter with notes and questions
   * @param data The chapter data with notes and questions
   * @returns Promise that resolves to a response with the created chapter ID
   */
  async createChapterNotes(data: ChapterNotesRequest): Promise<ChapterNotesResponse> {

    // Create a copy of the data with escaped single quotes
    const escapedData: ChapterNotesRequest = {
      chapter: data.chapter,
      subject_id: data.subject_id,
      notes: data.notes.map(note => ({
        content: note.content,
        questions: note.questions ? note.questions.map(q => ({
          question: q.question,
          answer: q.answer
        })) : []
      }))
    };
    
    const response = await apiClient.post<ApiResponse<ChapterNotesResponse>>(
      '/chapternotes', 
      escapedData
    );
    
    return response.data.data;
  },

  /**
   * Get complete chapter data including all notes and questions in a single request
   * @param chapterId The ID of the chapter to retrieve
   * @returns Promise that resolves to the complete chapter data
   */
  async getChapterNotes(chapterId: number): Promise<ChapterNotesData> {
    const response = await apiClient.get<ApiResponse<ChapterNotesData>>(
      `/chapternotes/${chapterId}`
    );
    return response.data.data;
  }
};